import { Box, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Need_Admin_Approval.module.css";

const sortOrdersByLatestFirst = (items) =>
  [...(Array.isArray(items) ? items : [])].sort((a, b) => {
    const aTime = new Date(
      a?.createdAt || a?.created_at || a?.updatedAt || a?.updated_at || 0,
    ).getTime();
    const bTime = new Date(
      b?.createdAt || b?.created_at || b?.updatedAt || b?.updated_at || 0,
    ).getTime();
    if (aTime !== bTime) return bTime - aTime;
    return Number(b?.id || 0) - Number(a?.id || 0);
  });

function NeedAdminApproval() {
  const [allOrders, setAllOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    fetchOrders();
  }, []);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/need_admin_approval`,
        {
          method: "GET",
          credentials: "include",
        },
      );
      const data = await response.json();
      if (data.success) {
        setAllOrders(sortOrdersByLatestFirst(data.data));
      }
    } catch (error) {
      console.error("Error fetching approval orders:", error);
    } finally {
      setLoading(false);
    }
  };

  const clickCardHandler = (item, id, index) => {
    navigate(`/dashboard/tracking/${id}`, {
      state: {
        orders: allOrders,
        item: item,
        index: index,
        type: "need_admin_approval",
      },
    });
  };

  return (
    <div>
      <div className={styles.Container}>
        {loading && (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CircularProgress />
          </Box>
        )}
        <ul className={styles.List}>
          {Array.isArray(allOrders) &&
            allOrders.length !== 0 &&
            allOrders.map((item, index) => {
              const { id, marketplaceName, status, ticket_id, awaiting_approval } = item;
              return (
                <li key={id} className={styles.ListItem}>
                  <div
                    className={styles.Card}
                    onClick={() => {
                      clickCardHandler(item, ticket_id, index);
                    }}
                  >
                    <div className={styles.CardContent}>
                      <div className={styles.InfoSection}>
                        <h6 className={styles.Title}>{marketplaceName}</h6>
                        <div className={styles.InfoIds}>
                          <p className={styles.IdText}>Order Id : {id}</p>
                          <p className={styles.IdText}>
                            Ticket Id : {ticket_id}
                          </p>
                        </div>
                        {/* Held: nothing is fulfilled until it is approved. */}
                        {awaiting_approval && (
                          <p
                            style={{
                              margin: "4px 0 0",
                              display: "inline-block",
                              padding: "2px 8px",
                              borderRadius: 999,
                              fontSize: 11.5,
                              fontWeight: 700,
                              background: "#fef7e6",
                              color: "#8a5000",
                              border: "1px solid #f5d49a",
                            }}
                          >
                            Waiting for your approval — on hold
                          </p>
                        )}
                      </div>
                    </div>
                    <div className={styles.StatusWrapper}>
                      <div
                        className={styles.StatusBadge}
                        // statusData[status]
                        // ? "text-white"
                        // : "bg-gray-800 text-white"

                        // style={
                        //   statusData[status]
                        //     ? {
                        //         backgroundColor: statusData[status],
                        //         borderColor: statusData[status],
                        //       }
                        //     : {}
                        // }
                      >
                        {status}
                      </div>
                    </div>
                  </div>
                </li>
              );
            })}
        </ul>
        {allOrders?.length === 0 && allOrders && !loading && (
          <div className={styles.EmptyContainer}>
            <center>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                {/* <NoTrack style={{ height: "50vh" }}></NoTrack> */}
                <h2 style={{ margin: 0, marginLeft: "3%" }}>
                  No Admin Approvals Orders Yet
                </h2>
                <p
                  style={{
                    marginTop: 0,
                    marginLeft: "3%",
                    fontSize: "12px",
                  }}
                >
                  Purchase Your First Software
                </p>
                <button
                  className={styles.PurchaseButton}
                  // onClick={() => navigate("/marketplace")}
                >
                  Purchase
                </button>
              </Box>
            </center>
          </div>
        )}
      </div>
    </div>
  );
}

export default NeedAdminApproval;
